// extracted by mini-css-extract-plugin
export default {"marquee":"NewsCard_marquee__NNKhQ","marqueeContent":"NewsCard_marqueeContent__lkyHD","runningText":"NewsCard_runningText__t-SIX"};